import styled from 'styled-components';

export default styled.div`
	grid-template-columns: 1fr 1fr;
	display: grid;
	gap: var(--spacing-large);
	justify-content: center;

	.motif-chip .motif-chip-button {
		background-color: transparent;
	}
	.card-content {
		gap: var(--spacing-large);
		width: 100%;
	}
	.modal-section {
		grid-column-start: 1;
		grid-column-end: 3;
		justify-content: space-around;
		gap: var(--spacing-large);
		display: flex;
		flex-direction: column;
		&.contact-data {
			display: flex;
			flex-direction: column;
			gap: var(--spacing-medium);
			text-align: center;
			display: grid;
			border-bottom: 1px solid var(--modal-header-border-color);
			.user-profile {
				display: flex;
				flex-direction: column;
				gap: var(--spacing-large);
			}
			.personal-information {
				display: flex;
				flex-direction: column;
				align-items: center;
			}
			.rol {
				display: flex;
				gap: var(--spacing-large);
				justify-content: center;
				.circulo {
					width: 4px;
					height: 4px;
					border-radius: 50%;
					border: 3px solid var(--neutrals-300);
					display: flex;
					align-content: center;
					flex-wrap: wrap;
					align-self: center;
				}
			}
		}
		.chip-group {
			display: flex;
			flex-wrap: wrap;
			.motif-chip {
				padding-right: var(--spacing-medium);
				padding-bottom: 0.7rem;
			}
		}

		.group-access,
		.customColumns {
			display: flex;
			flex-direction: column;
			gap: 0.75rem;
			.flex-1-inline-horizontal {
				flex-direction: row;
				display: flex;
				justify-content: space-between;
				gap: var(--spacing-x-small);
			}

			.prop-value {
				margin-right: 0.75rem;
			}
		}

		&.section-custom-attributes {
			grid-column-start: 2;
			grid-row-start: 2;
			grid-row-end: 4;
		}
	}
`;
